// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/types/wallet.proto" (package "mlmbox.types", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Bonus_Kind_Id } from "./bonus.ts";
import { Account_Info } from "./account.ts";
import { Asset_Amount } from "./asset.ts";
import { Status_Transaction } from "./status.ts";
import { Bonus_Summary } from "./bonus.ts";
/**
 * @generated from protobuf message mlmbox.types.Wallet
 */
export interface Wallet {
    /**
     * @generated from protobuf field: repeated mlmbox.types.Wallet.Asset assets = 1;
     */
    assets: Wallet_Asset[];
    /**
     * @generated from protobuf field: repeated mlmbox.types.Wallet.Processing processings = 2;
     */
    processings: Wallet_Processing[];
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Asset
 */
export interface Wallet_Asset {
    /**
     * @generated from protobuf field: uint32 asset_id = 1;
     */
    assetId: number;
    /**
     * @generated from protobuf field: string asset_balance = 2;
     */
    assetBalance: string;
    /**
     * @generated from protobuf field: repeated mlmbox.types.Wallet.Asset.Transaction transactions = 3;
     */
    transactions: Wallet_Asset_Transaction[];
    /**
     * @generated from protobuf field: mlmbox.types.Bonus.Summary income_bonuses_statistics = 4;
     */
    incomeBonusesStatistics?: Bonus_Summary;
    /**
     * @generated from protobuf field: mlmbox.types.Wallet.Asset.WithdrawalCapacity withdrawal_capacity = 5;
     */
    withdrawalCapacity?: Wallet_Asset_WithdrawalCapacity;
    /**
     * @generated from protobuf field: bool settings_transfer_enabled = 6;
     */
    settingsTransferEnabled: boolean;
    /**
     * @generated from protobuf field: string settings_transfer_limit_min = 7;
     */
    settingsTransferLimitMin: string;
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Asset.Transaction
 */
export interface Wallet_Asset_Transaction {
    /**
     * @generated from protobuf field: uint32 transaction_id = 1;
     */
    transactionId: number;
    /**
     * @generated from protobuf field: mlmbox.types.Wallet.Asset.Transaction.Kind.Id kind_id = 2;
     */
    kindId: Wallet_Asset_Transaction_Kind_Id;
    /**
     * @generated from protobuf field: mlmbox.types.Status.Transaction status_id = 3;
     */
    statusId: Status_Transaction;
    /**
     * @generated from protobuf field: string amount = 4;
     */
    amount: string;
    /**
     * @generated from protobuf field: string fee = 5;
     */
    fee: string;
    /**
     * @generated from protobuf field: string balance = 6;
     */
    balance: string;
    /**
     * @generated from protobuf field: uint32 created_at = 7;
     */
    createdAt: number;
    /**
     * @generated from protobuf field: mlmbox.types.Wallet.Asset.Transaction.Metadata metadata = 8;
     */
    metadata?: Wallet_Asset_Transaction_Metadata;
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Asset.Transaction.Id
 */
export interface Wallet_Asset_Transaction_Id {
    /**
     * @generated from protobuf field: uint32 asset_id = 1;
     */
    assetId: number;
    /**
     * @generated from protobuf field: uint32 transaction_id = 2;
     */
    transactionId: number;
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Asset.Transaction.Kind
 */
export interface Wallet_Asset_Transaction_Kind {
    /**
     * @generated from protobuf field: mlmbox.types.Wallet.Asset.Transaction.Kind.Id kind_id = 1;
     */
    kindId: Wallet_Asset_Transaction_Kind_Id;
}
/**
 * @generated from protobuf enum mlmbox.types.Wallet.Asset.Transaction.Kind.Id
 */
export enum Wallet_Asset_Transaction_Kind_Id {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: CANCELED = 1;
     */
    CANCELED = 1,
    /**
     * Заработано
     *
     * @generated from protobuf enum value: EARNED = 2;
     */
    EARNED = 2,
    /**
     * Потрачено
     *
     * @generated from protobuf enum value: SPENT = 3;
     */
    SPENT = 3,
    /**
     * Пополнение
     *
     * @generated from protobuf enum value: DEPOSIT = 4;
     */
    DEPOSIT = 4,
    /**
     * Вывод
     *
     * @generated from protobuf enum value: WITHDRAWAL = 5;
     */
    WITHDRAWAL = 5,
    /**
     * Перевод между кошельками (получение)
     *
     * @generated from protobuf enum value: DEPOSIT_WALLET_TRANSFER = 6;
     */
    DEPOSIT_WALLET_TRANSFER = 6,
    /**
     * Перевод между кошельками (отправка)
     *
     * @generated from protobuf enum value: WITHDRAWAL_WALLET_TRANSFER = 7;
     */
    WITHDRAWAL_WALLET_TRANSFER = 7,
    /**
     * Обмен валюты
     *
     * @generated from protobuf enum value: EXCHANGE = 8;
     */
    EXCHANGE = 8,
    /**
     * Комиссия для вывода
     *
     * @generated from protobuf enum value: WITHDRAWAL_FEE = 9;
     */
    WITHDRAWAL_FEE = 9,
    /**
     * Сжигание баланса
     *
     * @generated from protobuf enum value: BURNED = 10;
     */
    BURNED = 10,
    /**
     * Удержание баланса
     *
     * @generated from protobuf enum value: HOLD = 11;
     */
    HOLD = 11,
    /**
     * Освобождение баланса
     *
     * @generated from protobuf enum value: UNHOLD = 12;
     */
    UNHOLD = 12
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Asset.Transaction.List
 */
export interface Wallet_Asset_Transaction_List {
    /**
     * @generated from protobuf field: repeated mlmbox.types.Wallet.Asset.Transaction items = 1;
     */
    items: Wallet_Asset_Transaction[];
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata
 */
export interface Wallet_Asset_Transaction_Metadata {
    /**
     * @generated from protobuf oneof: unique_field
     */
    uniqueField: {
        oneofKind: "description";
        /**
         * @generated from protobuf field: string description = 1;
         */
        description: string;
    } | {
        oneofKind: "withdrawal";
        /**
         * @generated from protobuf field: mlmbox.types.Wallet.Asset.Transaction.Metadata.Withdrawal withdrawal = 2;
         */
        withdrawal: Wallet_Asset_Transaction_Metadata_Withdrawal;
    } | {
        oneofKind: "keeperInitialTreeId";
        /**
         * @generated from protobuf field: uint32 keeper_initial_tree_id = 3;
         */
        keeperInitialTreeId: number;
    } | {
        oneofKind: "keeperReinvest";
        /**
         * @generated from protobuf field: mlmbox.types.Wallet.Asset.Transaction.Metadata.PositionHeader keeper_reinvest = 4;
         */
        keeperReinvest: Wallet_Asset_Transaction_Metadata_PositionHeader;
    } | {
        oneofKind: "bonus";
        /**
         * @generated from protobuf field: mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus bonus = 5;
         */
        bonus: Wallet_Asset_Transaction_Metadata_Bonus;
    } | {
        oneofKind: "accountId";
        /**
         * @generated from protobuf field: uint32 account_id = 6;
         */
        accountId: number;
    } | {
        oneofKind: "positionCreated";
        /**
         * @generated from protobuf field: mlmbox.types.Wallet.Asset.Transaction.Metadata.PositionHeader position_created = 7;
         */
        positionCreated: Wallet_Asset_Transaction_Metadata_PositionHeader;
    } | {
        oneofKind: "amount";
        /**
         * @generated from protobuf field: mlmbox.types.Asset.Amount amount = 8;
         */
        amount: Asset_Amount;
    } | {
        oneofKind: "keeperBookingTreeId";
        /**
         * @generated from protobuf field: uint32 keeper_booking_tree_id = 9;
         */
        keeperBookingTreeId: number;
    } | {
        oneofKind: "deposit";
        /**
         * @generated from protobuf field: mlmbox.types.Wallet.Asset.Transaction.Metadata.Deposit deposit = 10;
         */
        deposit: Wallet_Asset_Transaction_Metadata_Deposit;
    } | {
        oneofKind: "account";
        /**
         * @generated from protobuf field: mlmbox.types.Account.Info account = 11;
         */
        account: Account_Info;
    } | {
        oneofKind: "transactionId";
        /**
         * @generated from protobuf field: uint32 transaction_id = 12;
         */
        transactionId: number;
    } | {
        oneofKind: "giftShopCardId";
        /**
         * @generated from protobuf field: uint32 gift_shop_card_id = 13;
         */
        giftShopCardId: number;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Deposit
 */
export interface Wallet_Asset_Transaction_Metadata_Deposit {
    /**
     * @generated from protobuf field: uint32 processing_id = 1;
     */
    processingId: number;
    /**
     * @generated from protobuf field: string hash = 2;
     */
    hash: string;
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Withdrawal
 */
export interface Wallet_Asset_Transaction_Metadata_Withdrawal {
    /**
     * @generated from protobuf field: uint32 processing_id = 1;
     */
    processingId: number;
    /**
     * @generated from protobuf field: string address = 2;
     */
    address: string;
    /**
     * @generated from protobuf field: bool used_verified_code = 3;
     */
    usedVerifiedCode: boolean;
    /**
     * @generated from protobuf field: string hash = 4;
     */
    hash: string;
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.PositionHeader
 */
export interface Wallet_Asset_Transaction_Metadata_PositionHeader {
    /**
     * @generated from protobuf field: uint32 tree_id = 1;
     */
    treeId: number;
    /**
     * @generated from protobuf field: uint32 tree_account_entity_id = 2;
     */
    treeAccountEntityId: number;
    /**
     * @generated from protobuf field: uint32 position_id = 3;
     */
    positionId: number;
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus
 */
export interface Wallet_Asset_Transaction_Metadata_Bonus {
    /**
     * @generated from protobuf field: mlmbox.types.Bonus.Kind.Id bonus_id = 1;
     */
    bonusId: Bonus_Kind_Id;
    /**
     * @generated from protobuf oneof: source
     */
    source: {
        oneofKind: "matrix";
        /**
         * @generated from protobuf field: mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.SourceMatrix matrix = 2;
         */
        matrix: Wallet_Asset_Transaction_Metadata_Bonus_SourceMatrix;
    } | {
        oneofKind: "cardPartnerDao";
        /**
         * @generated from protobuf field: mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.CardPool card_partner_dao = 3;
         */
        cardPartnerDao: Wallet_Asset_Transaction_Metadata_Bonus_CardPool;
    } | {
        oneofKind: "cardBonusHunter";
        /**
         * @generated from protobuf field: mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.CardPool card_bonus_hunter = 4;
         */
        cardBonusHunter: Wallet_Asset_Transaction_Metadata_Bonus_CardPool;
    } | {
        oneofKind: "description";
        /**
         * @generated from protobuf field: string description = 5;
         */
        description: string;
    } | {
        oneofKind: "binary";
        /**
         * @generated from protobuf field: mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.SourceBinary binary = 6;
         */
        binary: Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary;
    } | {
        oneofKind: "binaryMatching";
        /**
         * @generated from protobuf field: mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.SourceBinaryMatching binary_matching = 7;
         */
        binaryMatching: Wallet_Asset_Transaction_Metadata_Bonus_SourceBinaryMatching;
    } | {
        oneofKind: "gameTokenWeb3PurchasePersonal";
        /**
         * @generated from protobuf field: mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Web3Purchase.Personal game_token_web3_purchase_personal = 8;
         */
        gameTokenWeb3PurchasePersonal: Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Personal;
    } | {
        oneofKind: "gameTokenWeb3PurchasePartners";
        /**
         * @generated from protobuf field: mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Web3Purchase.Partners game_token_web3_purchase_partners = 9;
         */
        gameTokenWeb3PurchasePartners: Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Partners;
    } | {
        oneofKind: "gameTokenExchangePersonal";
        /**
         * @generated from protobuf field: mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Exchange.Personal game_token_exchange_personal = 10;
         */
        gameTokenExchangePersonal: Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Personal;
    } | {
        oneofKind: "gameTokenExchangePartners";
        /**
         * @generated from protobuf field: mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Exchange.Partners game_token_exchange_partners = 11;
         */
        gameTokenExchangePartners: Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Partners;
    } | {
        oneofKind: "gameTokenPromotionTopMatrix";
        /**
         * @generated from protobuf field: mlmbox.types.Wallet.Asset.Transaction.Metadata.PositionHeader game_token_promotion_top_matrix = 12;
         */
        gameTokenPromotionTopMatrix: Wallet_Asset_Transaction_Metadata_PositionHeader;
    } | {
        oneofKind: "gameTokenPromotionBinary";
        /**
         * @generated from protobuf field: mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.SourceBinary.Partner game_token_promotion_binary = 13;
         */
        gameTokenPromotionBinary: Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary_Partner;
    } | {
        oneofKind: "gameTokenPromotionCashback";
        /**
         * @generated from protobuf field: mlmbox.types.Wallet.Asset.Transaction.Metadata.PositionHeader game_token_promotion_cashback = 14;
         */
        gameTokenPromotionCashback: Wallet_Asset_Transaction_Metadata_PositionHeader;
    } | {
        oneofKind: "withdrawalGiftShopCardId";
        /**
         * @generated from protobuf field: uint32 withdrawal_gift_shop_card_id = 15;
         */
        withdrawalGiftShopCardId: number;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.SourceMatrix
 */
export interface Wallet_Asset_Transaction_Metadata_Bonus_SourceMatrix {
    /**
     * @generated from protobuf field: mlmbox.types.Wallet.Asset.Transaction.Metadata.PositionHeader target = 1;
     */
    target?: Wallet_Asset_Transaction_Metadata_PositionHeader;
    /**
     * @generated from protobuf field: mlmbox.types.Wallet.Asset.Transaction.Metadata.PositionHeader source = 2;
     */
    source?: Wallet_Asset_Transaction_Metadata_PositionHeader;
    /**
     * @generated from protobuf field: uint32 level = 3;
     */
    level: number;
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.SourceBinary
 */
export interface Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary {
    /**
     * @generated from protobuf field: uint32 tree_id = 1;
     */
    treeId: number;
    /**
     * @generated from protobuf field: uint32 position_id = 2;
     */
    positionId: number;
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.SourceBinary.Partner
 */
export interface Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary_Partner {
    /**
     * @generated from protobuf field: uint32 account_id = 1;
     */
    accountId: number;
    /**
     * @generated from protobuf field: uint32 tree_id = 2;
     */
    treeId: number;
    /**
     * @generated from protobuf field: uint32 position_id = 3;
     */
    positionId: number;
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.SourceBinaryMatching
 */
export interface Wallet_Asset_Transaction_Metadata_Bonus_SourceBinaryMatching {
    /**
     * @generated from protobuf field: uint32 tree_id = 1;
     */
    treeId: number;
    /**
     * @generated from protobuf field: uint32 source_account_id = 2;
     */
    sourceAccountId: number;
    /**
     * @generated from protobuf field: uint32 source_position_id = 3;
     */
    sourcePositionId: number;
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.CardPool
 */
export interface Wallet_Asset_Transaction_Metadata_Bonus_CardPool {
    /**
     * @generated from protobuf field: uint32 card_id = 1;
     */
    cardId: number;
    /**
     * @generated from protobuf field: uint32 pool_part_id = 2;
     */
    poolPartId: number;
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken
 */
export interface Wallet_Asset_Transaction_Metadata_Bonus_GameToken {
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Web3Purchase
 */
export interface Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase {
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Web3Purchase.Personal
 */
export interface Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Personal {
    /**
     * @generated from protobuf field: string transaction_hash = 1;
     */
    transactionHash: string;
    /**
     * @generated from protobuf field: string amount = 2;
     */
    amount: string;
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Web3Purchase.Partners
 */
export interface Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Partners {
    /**
     * @generated from protobuf field: uint32 account_id = 1;
     */
    accountId: number;
    /**
     * @generated from protobuf field: string transaction_hash = 2;
     */
    transactionHash: string;
    /**
     * @generated from protobuf field: string amount = 3;
     */
    amount: string;
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Exchange
 */
export interface Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange {
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Exchange.Personal
 */
export interface Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Personal {
    /**
     * @generated from protobuf field: mlmbox.types.Asset.Amount source = 1;
     */
    source?: Asset_Amount;
    /**
     * @generated from protobuf field: mlmbox.types.Asset.Amount target = 2;
     */
    target?: Asset_Amount;
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Exchange.Partners
 */
export interface Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Partners {
    /**
     * @generated from protobuf field: uint32 account_id = 1;
     */
    accountId: number;
    /**
     * @generated from protobuf field: mlmbox.types.Asset.Amount source = 2;
     */
    source?: Asset_Amount;
    /**
     * @generated from protobuf field: mlmbox.types.Asset.Amount target = 3;
     */
    target?: Asset_Amount;
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Asset.WithdrawalCapacity
 */
export interface Wallet_Asset_WithdrawalCapacity {
    /**
     * @generated from protobuf field: string used = 1;
     */
    used: string; // The value of the volume used
    /**
     * @generated from protobuf field: string capacity = 2;
     */
    capacity: string; // Limit value
    /**
     * @generated from protobuf field: string available = 3;
     */
    available: string; // Remaining available volume
    /**
     * @generated from protobuf field: bool enabled = 4;
     */
    enabled: boolean; // Is the limit used
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Asset.List
 */
export interface Wallet_Asset_List {
    /**
     * @generated from protobuf field: repeated mlmbox.types.Wallet.Asset items = 1;
     */
    items: Wallet_Asset[];
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Processing
 */
export interface Wallet_Processing {
    /**
     * @generated from protobuf field: uint32 processing_id = 1;
     */
    processingId: number;
    /**
     * @generated from protobuf field: string processing_name = 2;
     */
    processingName: string;
    /**
     * @generated from protobuf field: repeated mlmbox.types.Wallet.Processing.Asset assets = 3;
     */
    assets: Wallet_Processing_Asset[];
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Processing.Id
 */
export interface Wallet_Processing_Id {
    /**
     * @generated from protobuf field: uint32 processing_id = 1;
     */
    processingId: number;
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Processing.Asset
 */
export interface Wallet_Processing_Asset {
    /**
     * @generated from protobuf field: uint32 asset_id = 1;
     */
    assetId: number;
    /**
     * @generated from protobuf field: bool settings_deposit_enabled = 2;
     */
    settingsDepositEnabled: boolean;
    /**
     * @generated from protobuf field: bool settings_withdrawal_enabled = 3;
     */
    settingsWithdrawalEnabled: boolean;
    /**
     * @generated from protobuf field: string settings_withdrawal_fee_base = 4;
     */
    settingsWithdrawalFeeBase: string;
    /**
     * @generated from protobuf field: string settings_withdrawal_fee_percent = 5;
     */
    settingsWithdrawalFeePercent: string;
    /**
     * @generated from protobuf field: string settings_withdrawal_operation_value_min = 6;
     */
    settingsWithdrawalOperationValueMin: string;
    /**
     * @generated from protobuf field: string settings_withdrawal_operation_value_max = 7;
     */
    settingsWithdrawalOperationValueMax: string;
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Processing.Asset.Id
 */
export interface Wallet_Processing_Asset_Id {
    /**
     * @generated from protobuf field: uint32 processing_id = 1;
     */
    processingId: number;
    /**
     * @generated from protobuf field: uint32 asset_id = 2;
     */
    assetId: number;
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Processing.Asset.WithdrawalAddressHistory
 */
export interface Wallet_Processing_Asset_WithdrawalAddressHistory {
    /**
     * @generated from protobuf field: repeated mlmbox.types.Wallet.Processing.Asset.WithdrawalAddressHistory.Value items = 1;
     */
    items: Wallet_Processing_Asset_WithdrawalAddressHistory_Value[];
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Processing.Asset.WithdrawalAddressHistory.Value
 */
export interface Wallet_Processing_Asset_WithdrawalAddressHistory_Value {
    /**
     * @generated from protobuf field: string address = 3;
     */
    address: string;
    /**
     * @generated from protobuf field: uint32 last_used_at = 4;
     */
    lastUsedAt: number;
}
/**
 * @generated from protobuf message mlmbox.types.Wallet.Processing.List
 */
export interface Wallet_Processing_List {
    /**
     * @generated from protobuf field: repeated mlmbox.types.Wallet.Processing items = 1;
     */
    items: Wallet_Processing[];
}
// @generated message type with reflection information, may provide speed optimized methods
class Wallet$Type extends MessageType<Wallet> {
    constructor() {
        super("mlmbox.types.Wallet", [
            { no: 1, name: "assets", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Wallet_Asset },
            { no: 2, name: "processings", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Wallet_Processing }
        ]);
    }
    create(value?: PartialMessage<Wallet>): Wallet {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.assets = [];
        message.processings = [];
        if (value !== undefined)
            reflectionMergePartial<Wallet>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet): Wallet {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated mlmbox.types.Wallet.Asset assets */ 1:
                    message.assets.push(Wallet_Asset.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated mlmbox.types.Wallet.Processing processings */ 2:
                    message.processings.push(Wallet_Processing.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wallet, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated mlmbox.types.Wallet.Asset assets = 1; */
        for (let i = 0; i < message.assets.length; i++)
            Wallet_Asset.internalBinaryWrite(message.assets[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated mlmbox.types.Wallet.Processing processings = 2; */
        for (let i = 0; i < message.processings.length; i++)
            Wallet_Processing.internalBinaryWrite(message.processings[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet
 */
export const Wallet = new Wallet$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Asset$Type extends MessageType<Wallet_Asset> {
    constructor() {
        super("mlmbox.types.Wallet.Asset", [
            { no: 1, name: "asset_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "asset_balance", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "transactions", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Wallet_Asset_Transaction },
            { no: 4, name: "income_bonuses_statistics", kind: "message", T: () => Bonus_Summary },
            { no: 5, name: "withdrawal_capacity", kind: "message", T: () => Wallet_Asset_WithdrawalCapacity },
            { no: 6, name: "settings_transfer_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "settings_transfer_limit_min", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Wallet_Asset>): Wallet_Asset {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.assetId = 0;
        message.assetBalance = "";
        message.transactions = [];
        message.settingsTransferEnabled = false;
        message.settingsTransferLimitMin = "";
        if (value !== undefined)
            reflectionMergePartial<Wallet_Asset>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Asset): Wallet_Asset {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 asset_id */ 1:
                    message.assetId = reader.uint32();
                    break;
                case /* string asset_balance */ 2:
                    message.assetBalance = reader.string();
                    break;
                case /* repeated mlmbox.types.Wallet.Asset.Transaction transactions */ 3:
                    message.transactions.push(Wallet_Asset_Transaction.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* mlmbox.types.Bonus.Summary income_bonuses_statistics */ 4:
                    message.incomeBonusesStatistics = Bonus_Summary.internalBinaryRead(reader, reader.uint32(), options, message.incomeBonusesStatistics);
                    break;
                case /* mlmbox.types.Wallet.Asset.WithdrawalCapacity withdrawal_capacity */ 5:
                    message.withdrawalCapacity = Wallet_Asset_WithdrawalCapacity.internalBinaryRead(reader, reader.uint32(), options, message.withdrawalCapacity);
                    break;
                case /* bool settings_transfer_enabled */ 6:
                    message.settingsTransferEnabled = reader.bool();
                    break;
                case /* string settings_transfer_limit_min */ 7:
                    message.settingsTransferLimitMin = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wallet_Asset, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 asset_id = 1; */
        if (message.assetId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.assetId);
        /* string asset_balance = 2; */
        if (message.assetBalance !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.assetBalance);
        /* repeated mlmbox.types.Wallet.Asset.Transaction transactions = 3; */
        for (let i = 0; i < message.transactions.length; i++)
            Wallet_Asset_Transaction.internalBinaryWrite(message.transactions[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Bonus.Summary income_bonuses_statistics = 4; */
        if (message.incomeBonusesStatistics)
            Bonus_Summary.internalBinaryWrite(message.incomeBonusesStatistics, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Wallet.Asset.WithdrawalCapacity withdrawal_capacity = 5; */
        if (message.withdrawalCapacity)
            Wallet_Asset_WithdrawalCapacity.internalBinaryWrite(message.withdrawalCapacity, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* bool settings_transfer_enabled = 6; */
        if (message.settingsTransferEnabled !== false)
            writer.tag(6, WireType.Varint).bool(message.settingsTransferEnabled);
        /* string settings_transfer_limit_min = 7; */
        if (message.settingsTransferLimitMin !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.settingsTransferLimitMin);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Asset
 */
export const Wallet_Asset = new Wallet_Asset$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Asset_Transaction$Type extends MessageType<Wallet_Asset_Transaction> {
    constructor() {
        super("mlmbox.types.Wallet.Asset.Transaction", [
            { no: 1, name: "transaction_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "kind_id", kind: "enum", T: () => ["mlmbox.types.Wallet.Asset.Transaction.Kind.Id", Wallet_Asset_Transaction_Kind_Id] },
            { no: 3, name: "status_id", kind: "enum", T: () => ["mlmbox.types.Status.Transaction", Status_Transaction, "TRANSACTION_"] },
            { no: 4, name: "amount", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "fee", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "balance", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "created_at", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 8, name: "metadata", kind: "message", T: () => Wallet_Asset_Transaction_Metadata }
        ]);
    }
    create(value?: PartialMessage<Wallet_Asset_Transaction>): Wallet_Asset_Transaction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.transactionId = 0;
        message.kindId = 0;
        message.statusId = 0;
        message.amount = "";
        message.fee = "";
        message.balance = "";
        message.createdAt = 0;
        if (value !== undefined)
            reflectionMergePartial<Wallet_Asset_Transaction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Asset_Transaction): Wallet_Asset_Transaction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 transaction_id */ 1:
                    message.transactionId = reader.uint32();
                    break;
                case /* mlmbox.types.Wallet.Asset.Transaction.Kind.Id kind_id */ 2:
                    message.kindId = reader.int32();
                    break;
                case /* mlmbox.types.Status.Transaction status_id */ 3:
                    message.statusId = reader.int32();
                    break;
                case /* string amount */ 4:
                    message.amount = reader.string();
                    break;
                case /* string fee */ 5:
                    message.fee = reader.string();
                    break;
                case /* string balance */ 6:
                    message.balance = reader.string();
                    break;
                case /* uint32 created_at */ 7:
                    message.createdAt = reader.uint32();
                    break;
                case /* mlmbox.types.Wallet.Asset.Transaction.Metadata metadata */ 8:
                    message.metadata = Wallet_Asset_Transaction_Metadata.internalBinaryRead(reader, reader.uint32(), options, message.metadata);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wallet_Asset_Transaction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 transaction_id = 1; */
        if (message.transactionId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.transactionId);
        /* mlmbox.types.Wallet.Asset.Transaction.Kind.Id kind_id = 2; */
        if (message.kindId !== 0)
            writer.tag(2, WireType.Varint).int32(message.kindId);
        /* mlmbox.types.Status.Transaction status_id = 3; */
        if (message.statusId !== 0)
            writer.tag(3, WireType.Varint).int32(message.statusId);
        /* string amount = 4; */
        if (message.amount !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.amount);
        /* string fee = 5; */
        if (message.fee !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.fee);
        /* string balance = 6; */
        if (message.balance !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.balance);
        /* uint32 created_at = 7; */
        if (message.createdAt !== 0)
            writer.tag(7, WireType.Varint).uint32(message.createdAt);
        /* mlmbox.types.Wallet.Asset.Transaction.Metadata metadata = 8; */
        if (message.metadata)
            Wallet_Asset_Transaction_Metadata.internalBinaryWrite(message.metadata, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Asset.Transaction
 */
export const Wallet_Asset_Transaction = new Wallet_Asset_Transaction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Asset_Transaction_Id$Type extends MessageType<Wallet_Asset_Transaction_Id> {
    constructor() {
        super("mlmbox.types.Wallet.Asset.Transaction.Id", [
            { no: 1, name: "asset_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "transaction_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Wallet_Asset_Transaction_Id>): Wallet_Asset_Transaction_Id {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.assetId = 0;
        message.transactionId = 0;
        if (value !== undefined)
            reflectionMergePartial<Wallet_Asset_Transaction_Id>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Asset_Transaction_Id): Wallet_Asset_Transaction_Id {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 asset_id */ 1:
                    message.assetId = reader.uint32();
                    break;
                case /* uint32 transaction_id */ 2:
                    message.transactionId = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wallet_Asset_Transaction_Id, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 asset_id = 1; */
        if (message.assetId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.assetId);
        /* uint32 transaction_id = 2; */
        if (message.transactionId !== 0)
            writer.tag(2, WireType.Varint).uint32(message.transactionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Asset.Transaction.Id
 */
export const Wallet_Asset_Transaction_Id = new Wallet_Asset_Transaction_Id$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Asset_Transaction_Kind$Type extends MessageType<Wallet_Asset_Transaction_Kind> {
    constructor() {
        super("mlmbox.types.Wallet.Asset.Transaction.Kind", [
            { no: 1, name: "kind_id", kind: "enum", T: () => ["mlmbox.types.Wallet.Asset.Transaction.Kind.Id", Wallet_Asset_Transaction_Kind_Id] }
        ]);
    }
    create(value?: PartialMessage<Wallet_Asset_Transaction_Kind>): Wallet_Asset_Transaction_Kind {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.kindId = 0;
        if (value !== undefined)
            reflectionMergePartial<Wallet_Asset_Transaction_Kind>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Asset_Transaction_Kind): Wallet_Asset_Transaction_Kind {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* mlmbox.types.Wallet.Asset.Transaction.Kind.Id kind_id */ 1:
                    message.kindId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wallet_Asset_Transaction_Kind, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* mlmbox.types.Wallet.Asset.Transaction.Kind.Id kind_id = 1; */
        if (message.kindId !== 0)
            writer.tag(1, WireType.Varint).int32(message.kindId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Asset.Transaction.Kind
 */
export const Wallet_Asset_Transaction_Kind = new Wallet_Asset_Transaction_Kind$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Asset_Transaction_List$Type extends MessageType<Wallet_Asset_Transaction_List> {
    constructor() {
        super("mlmbox.types.Wallet.Asset.Transaction.List", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Wallet_Asset_Transaction }
        ]);
    }
    create(value?: PartialMessage<Wallet_Asset_Transaction_List>): Wallet_Asset_Transaction_List {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<Wallet_Asset_Transaction_List>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Asset_Transaction_List): Wallet_Asset_Transaction_List {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated mlmbox.types.Wallet.Asset.Transaction items */ 1:
                    message.items.push(Wallet_Asset_Transaction.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wallet_Asset_Transaction_List, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated mlmbox.types.Wallet.Asset.Transaction items = 1; */
        for (let i = 0; i < message.items.length; i++)
            Wallet_Asset_Transaction.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Asset.Transaction.List
 */
export const Wallet_Asset_Transaction_List = new Wallet_Asset_Transaction_List$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Asset_Transaction_Metadata$Type extends MessageType<Wallet_Asset_Transaction_Metadata> {
    constructor() {
        super("mlmbox.types.Wallet.Asset.Transaction.Metadata", [
            { no: 1, name: "description", kind: "scalar", oneof: "uniqueField", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "withdrawal", kind: "message", oneof: "uniqueField", T: () => Wallet_Asset_Transaction_Metadata_Withdrawal },
            { no: 3, name: "keeper_initial_tree_id", kind: "scalar", oneof: "uniqueField", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "keeper_reinvest", kind: "message", oneof: "uniqueField", T: () => Wallet_Asset_Transaction_Metadata_PositionHeader },
            { no: 5, name: "bonus", kind: "message", oneof: "uniqueField", T: () => Wallet_Asset_Transaction_Metadata_Bonus },
            { no: 6, name: "account_id", kind: "scalar", oneof: "uniqueField", T: 13 /*ScalarType.UINT32*/ },
            { no: 7, name: "position_created", kind: "message", oneof: "uniqueField", T: () => Wallet_Asset_Transaction_Metadata_PositionHeader },
            { no: 8, name: "amount", kind: "message", oneof: "uniqueField", T: () => Asset_Amount },
            { no: 9, name: "keeper_booking_tree_id", kind: "scalar", oneof: "uniqueField", T: 13 /*ScalarType.UINT32*/ },
            { no: 10, name: "deposit", kind: "message", oneof: "uniqueField", T: () => Wallet_Asset_Transaction_Metadata_Deposit },
            { no: 11, name: "account", kind: "message", oneof: "uniqueField", T: () => Account_Info },
            { no: 12, name: "transaction_id", kind: "scalar", oneof: "uniqueField", T: 13 /*ScalarType.UINT32*/ },
            { no: 13, name: "gift_shop_card_id", kind: "scalar", oneof: "uniqueField", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Wallet_Asset_Transaction_Metadata>): Wallet_Asset_Transaction_Metadata {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.uniqueField = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<Wallet_Asset_Transaction_Metadata>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Asset_Transaction_Metadata): Wallet_Asset_Transaction_Metadata {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string description */ 1:
                    message.uniqueField = {
                        oneofKind: "description",
                        description: reader.string()
                    };
                    break;
                case /* mlmbox.types.Wallet.Asset.Transaction.Metadata.Withdrawal withdrawal */ 2:
                    message.uniqueField = {
                        oneofKind: "withdrawal",
                        withdrawal: Wallet_Asset_Transaction_Metadata_Withdrawal.internalBinaryRead(reader, reader.uint32(), options, (message.uniqueField as any).withdrawal)
                    };
                    break;
                case /* uint32 keeper_initial_tree_id */ 3:
                    message.uniqueField = {
                        oneofKind: "keeperInitialTreeId",
                        keeperInitialTreeId: reader.uint32()
                    };
                    break;
                case /* mlmbox.types.Wallet.Asset.Transaction.Metadata.PositionHeader keeper_reinvest */ 4:
                    message.uniqueField = {
                        oneofKind: "keeperReinvest",
                        keeperReinvest: Wallet_Asset_Transaction_Metadata_PositionHeader.internalBinaryRead(reader, reader.uint32(), options, (message.uniqueField as any).keeperReinvest)
                    };
                    break;
                case /* mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus bonus */ 5:
                    message.uniqueField = {
                        oneofKind: "bonus",
                        bonus: Wallet_Asset_Transaction_Metadata_Bonus.internalBinaryRead(reader, reader.uint32(), options, (message.uniqueField as any).bonus)
                    };
                    break;
                case /* uint32 account_id */ 6:
                    message.uniqueField = {
                        oneofKind: "accountId",
                        accountId: reader.uint32()
                    };
                    break;
                case /* mlmbox.types.Wallet.Asset.Transaction.Metadata.PositionHeader position_created */ 7:
                    message.uniqueField = {
                        oneofKind: "positionCreated",
                        positionCreated: Wallet_Asset_Transaction_Metadata_PositionHeader.internalBinaryRead(reader, reader.uint32(), options, (message.uniqueField as any).positionCreated)
                    };
                    break;
                case /* mlmbox.types.Asset.Amount amount */ 8:
                    message.uniqueField = {
                        oneofKind: "amount",
                        amount: Asset_Amount.internalBinaryRead(reader, reader.uint32(), options, (message.uniqueField as any).amount)
                    };
                    break;
                case /* uint32 keeper_booking_tree_id */ 9:
                    message.uniqueField = {
                        oneofKind: "keeperBookingTreeId",
                        keeperBookingTreeId: reader.uint32()
                    };
                    break;
                case /* mlmbox.types.Wallet.Asset.Transaction.Metadata.Deposit deposit */ 10:
                    message.uniqueField = {
                        oneofKind: "deposit",
                        deposit: Wallet_Asset_Transaction_Metadata_Deposit.internalBinaryRead(reader, reader.uint32(), options, (message.uniqueField as any).deposit)
                    };
                    break;
                case /* mlmbox.types.Account.Info account */ 11:
                    message.uniqueField = {
                        oneofKind: "account",
                        account: Account_Info.internalBinaryRead(reader, reader.uint32(), options, (message.uniqueField as any).account)
                    };
                    break;
                case /* uint32 transaction_id */ 12:
                    message.uniqueField = {
                        oneofKind: "transactionId",
                        transactionId: reader.uint32()
                    };
                    break;
                case /* uint32 gift_shop_card_id */ 13:
                    message.uniqueField = {
                        oneofKind: "giftShopCardId",
                        giftShopCardId: reader.uint32()
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wallet_Asset_Transaction_Metadata, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string description = 1; */
        if (message.uniqueField.oneofKind === "description")
            writer.tag(1, WireType.LengthDelimited).string(message.uniqueField.description);
        /* mlmbox.types.Wallet.Asset.Transaction.Metadata.Withdrawal withdrawal = 2; */
        if (message.uniqueField.oneofKind === "withdrawal")
            Wallet_Asset_Transaction_Metadata_Withdrawal.internalBinaryWrite(message.uniqueField.withdrawal, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* uint32 keeper_initial_tree_id = 3; */
        if (message.uniqueField.oneofKind === "keeperInitialTreeId")
            writer.tag(3, WireType.Varint).uint32(message.uniqueField.keeperInitialTreeId);
        /* mlmbox.types.Wallet.Asset.Transaction.Metadata.PositionHeader keeper_reinvest = 4; */
        if (message.uniqueField.oneofKind === "keeperReinvest")
            Wallet_Asset_Transaction_Metadata_PositionHeader.internalBinaryWrite(message.uniqueField.keeperReinvest, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus bonus = 5; */
        if (message.uniqueField.oneofKind === "bonus")
            Wallet_Asset_Transaction_Metadata_Bonus.internalBinaryWrite(message.uniqueField.bonus, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* uint32 account_id = 6; */
        if (message.uniqueField.oneofKind === "accountId")
            writer.tag(6, WireType.Varint).uint32(message.uniqueField.accountId);
        /* mlmbox.types.Wallet.Asset.Transaction.Metadata.PositionHeader position_created = 7; */
        if (message.uniqueField.oneofKind === "positionCreated")
            Wallet_Asset_Transaction_Metadata_PositionHeader.internalBinaryWrite(message.uniqueField.positionCreated, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Asset.Amount amount = 8; */
        if (message.uniqueField.oneofKind === "amount")
            Asset_Amount.internalBinaryWrite(message.uniqueField.amount, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* uint32 keeper_booking_tree_id = 9; */
        if (message.uniqueField.oneofKind === "keeperBookingTreeId")
            writer.tag(9, WireType.Varint).uint32(message.uniqueField.keeperBookingTreeId);
        /* mlmbox.types.Wallet.Asset.Transaction.Metadata.Deposit deposit = 10; */
        if (message.uniqueField.oneofKind === "deposit")
            Wallet_Asset_Transaction_Metadata_Deposit.internalBinaryWrite(message.uniqueField.deposit, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Account.Info account = 11; */
        if (message.uniqueField.oneofKind === "account")
            Account_Info.internalBinaryWrite(message.uniqueField.account, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* uint32 transaction_id = 12; */
        if (message.uniqueField.oneofKind === "transactionId")
            writer.tag(12, WireType.Varint).uint32(message.uniqueField.transactionId);
        /* uint32 gift_shop_card_id = 13; */
        if (message.uniqueField.oneofKind === "giftShopCardId")
            writer.tag(13, WireType.Varint).uint32(message.uniqueField.giftShopCardId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata
 */
export const Wallet_Asset_Transaction_Metadata = new Wallet_Asset_Transaction_Metadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Asset_Transaction_Metadata_Deposit$Type extends MessageType<Wallet_Asset_Transaction_Metadata_Deposit> {
    constructor() {
        super("mlmbox.types.Wallet.Asset.Transaction.Metadata.Deposit", [
            { no: 1, name: "processing_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "hash", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Wallet_Asset_Transaction_Metadata_Deposit>): Wallet_Asset_Transaction_Metadata_Deposit {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.processingId = 0;
        message.hash = "";
        if (value !== undefined)
            reflectionMergePartial<Wallet_Asset_Transaction_Metadata_Deposit>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Asset_Transaction_Metadata_Deposit): Wallet_Asset_Transaction_Metadata_Deposit {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 processing_id */ 1:
                    message.processingId = reader.uint32();
                    break;
                case /* string hash */ 2:
                    message.hash = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wallet_Asset_Transaction_Metadata_Deposit, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 processing_id = 1; */
        if (message.processingId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.processingId);
        /* string hash = 2; */
        if (message.hash !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.hash);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Deposit
 */
export const Wallet_Asset_Transaction_Metadata_Deposit = new Wallet_Asset_Transaction_Metadata_Deposit$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Asset_Transaction_Metadata_Withdrawal$Type extends MessageType<Wallet_Asset_Transaction_Metadata_Withdrawal> {
    constructor() {
        super("mlmbox.types.Wallet.Asset.Transaction.Metadata.Withdrawal", [
            { no: 1, name: "processing_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "used_verified_code", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "hash", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Wallet_Asset_Transaction_Metadata_Withdrawal>): Wallet_Asset_Transaction_Metadata_Withdrawal {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.processingId = 0;
        message.address = "";
        message.usedVerifiedCode = false;
        message.hash = "";
        if (value !== undefined)
            reflectionMergePartial<Wallet_Asset_Transaction_Metadata_Withdrawal>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Asset_Transaction_Metadata_Withdrawal): Wallet_Asset_Transaction_Metadata_Withdrawal {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 processing_id */ 1:
                    message.processingId = reader.uint32();
                    break;
                case /* string address */ 2:
                    message.address = reader.string();
                    break;
                case /* bool used_verified_code */ 3:
                    message.usedVerifiedCode = reader.bool();
                    break;
                case /* string hash */ 4:
                    message.hash = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wallet_Asset_Transaction_Metadata_Withdrawal, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 processing_id = 1; */
        if (message.processingId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.processingId);
        /* string address = 2; */
        if (message.address !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.address);
        /* bool used_verified_code = 3; */
        if (message.usedVerifiedCode !== false)
            writer.tag(3, WireType.Varint).bool(message.usedVerifiedCode);
        /* string hash = 4; */
        if (message.hash !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.hash);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Withdrawal
 */
export const Wallet_Asset_Transaction_Metadata_Withdrawal = new Wallet_Asset_Transaction_Metadata_Withdrawal$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Asset_Transaction_Metadata_PositionHeader$Type extends MessageType<Wallet_Asset_Transaction_Metadata_PositionHeader> {
    constructor() {
        super("mlmbox.types.Wallet.Asset.Transaction.Metadata.PositionHeader", [
            { no: 1, name: "tree_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "tree_account_entity_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "position_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Wallet_Asset_Transaction_Metadata_PositionHeader>): Wallet_Asset_Transaction_Metadata_PositionHeader {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.treeId = 0;
        message.treeAccountEntityId = 0;
        message.positionId = 0;
        if (value !== undefined)
            reflectionMergePartial<Wallet_Asset_Transaction_Metadata_PositionHeader>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Asset_Transaction_Metadata_PositionHeader): Wallet_Asset_Transaction_Metadata_PositionHeader {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 tree_id */ 1:
                    message.treeId = reader.uint32();
                    break;
                case /* uint32 tree_account_entity_id */ 2:
                    message.treeAccountEntityId = reader.uint32();
                    break;
                case /* uint32 position_id */ 3:
                    message.positionId = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wallet_Asset_Transaction_Metadata_PositionHeader, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 tree_id = 1; */
        if (message.treeId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.treeId);
        /* uint32 tree_account_entity_id = 2; */
        if (message.treeAccountEntityId !== 0)
            writer.tag(2, WireType.Varint).uint32(message.treeAccountEntityId);
        /* uint32 position_id = 3; */
        if (message.positionId !== 0)
            writer.tag(3, WireType.Varint).uint32(message.positionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.PositionHeader
 */
export const Wallet_Asset_Transaction_Metadata_PositionHeader = new Wallet_Asset_Transaction_Metadata_PositionHeader$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Asset_Transaction_Metadata_Bonus$Type extends MessageType<Wallet_Asset_Transaction_Metadata_Bonus> {
    constructor() {
        super("mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus", [
            { no: 1, name: "bonus_id", kind: "enum", T: () => ["mlmbox.types.Bonus.Kind.Id", Bonus_Kind_Id] },
            { no: 2, name: "matrix", kind: "message", oneof: "source", T: () => Wallet_Asset_Transaction_Metadata_Bonus_SourceMatrix },
            { no: 3, name: "card_partner_dao", kind: "message", oneof: "source", T: () => Wallet_Asset_Transaction_Metadata_Bonus_CardPool },
            { no: 4, name: "card_bonus_hunter", kind: "message", oneof: "source", T: () => Wallet_Asset_Transaction_Metadata_Bonus_CardPool },
            { no: 5, name: "description", kind: "scalar", oneof: "source", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "binary", kind: "message", oneof: "source", T: () => Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary },
            { no: 7, name: "binary_matching", kind: "message", oneof: "source", T: () => Wallet_Asset_Transaction_Metadata_Bonus_SourceBinaryMatching },
            { no: 8, name: "game_token_web3_purchase_personal", kind: "message", oneof: "source", T: () => Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Personal },
            { no: 9, name: "game_token_web3_purchase_partners", kind: "message", oneof: "source", T: () => Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Partners },
            { no: 10, name: "game_token_exchange_personal", kind: "message", oneof: "source", T: () => Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Personal },
            { no: 11, name: "game_token_exchange_partners", kind: "message", oneof: "source", T: () => Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Partners },
            { no: 12, name: "game_token_promotion_top_matrix", kind: "message", oneof: "source", T: () => Wallet_Asset_Transaction_Metadata_PositionHeader },
            { no: 13, name: "game_token_promotion_binary", kind: "message", oneof: "source", T: () => Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary_Partner },
            { no: 14, name: "game_token_promotion_cashback", kind: "message", oneof: "source", T: () => Wallet_Asset_Transaction_Metadata_PositionHeader },
            { no: 15, name: "withdrawal_gift_shop_card_id", kind: "scalar", oneof: "source", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Wallet_Asset_Transaction_Metadata_Bonus>): Wallet_Asset_Transaction_Metadata_Bonus {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bonusId = 0;
        message.source = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<Wallet_Asset_Transaction_Metadata_Bonus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Asset_Transaction_Metadata_Bonus): Wallet_Asset_Transaction_Metadata_Bonus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* mlmbox.types.Bonus.Kind.Id bonus_id */ 1:
                    message.bonusId = reader.int32();
                    break;
                case /* mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.SourceMatrix matrix */ 2:
                    message.source = {
                        oneofKind: "matrix",
                        matrix: Wallet_Asset_Transaction_Metadata_Bonus_SourceMatrix.internalBinaryRead(reader, reader.uint32(), options, (message.source as any).matrix)
                    };
                    break;
                case /* mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.CardPool card_partner_dao */ 3:
                    message.source = {
                        oneofKind: "cardPartnerDao",
                        cardPartnerDao: Wallet_Asset_Transaction_Metadata_Bonus_CardPool.internalBinaryRead(reader, reader.uint32(), options, (message.source as any).cardPartnerDao)
                    };
                    break;
                case /* mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.CardPool card_bonus_hunter */ 4:
                    message.source = {
                        oneofKind: "cardBonusHunter",
                        cardBonusHunter: Wallet_Asset_Transaction_Metadata_Bonus_CardPool.internalBinaryRead(reader, reader.uint32(), options, (message.source as any).cardBonusHunter)
                    };
                    break;
                case /* string description */ 5:
                    message.source = {
                        oneofKind: "description",
                        description: reader.string()
                    };
                    break;
                case /* mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.SourceBinary binary */ 6:
                    message.source = {
                        oneofKind: "binary",
                        binary: Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary.internalBinaryRead(reader, reader.uint32(), options, (message.source as any).binary)
                    };
                    break;
                case /* mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.SourceBinaryMatching binary_matching */ 7:
                    message.source = {
                        oneofKind: "binaryMatching",
                        binaryMatching: Wallet_Asset_Transaction_Metadata_Bonus_SourceBinaryMatching.internalBinaryRead(reader, reader.uint32(), options, (message.source as any).binaryMatching)
                    };
                    break;
                case /* mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Web3Purchase.Personal game_token_web3_purchase_personal */ 8:
                    message.source = {
                        oneofKind: "gameTokenWeb3PurchasePersonal",
                        gameTokenWeb3PurchasePersonal: Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Personal.internalBinaryRead(reader, reader.uint32(), options, (message.source as any).gameTokenWeb3PurchasePersonal)
                    };
                    break;
                case /* mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Web3Purchase.Partners game_token_web3_purchase_partners */ 9:
                    message.source = {
                        oneofKind: "gameTokenWeb3PurchasePartners",
                        gameTokenWeb3PurchasePartners: Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Partners.internalBinaryRead(reader, reader.uint32(), options, (message.source as any).gameTokenWeb3PurchasePartners)
                    };
                    break;
                case /* mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Exchange.Personal game_token_exchange_personal */ 10:
                    message.source = {
                        oneofKind: "gameTokenExchangePersonal",
                        gameTokenExchangePersonal: Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Personal.internalBinaryRead(reader, reader.uint32(), options, (message.source as any).gameTokenExchangePersonal)
                    };
                    break;
                case /* mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Exchange.Partners game_token_exchange_partners */ 11:
                    message.source = {
                        oneofKind: "gameTokenExchangePartners",
                        gameTokenExchangePartners: Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Partners.internalBinaryRead(reader, reader.uint32(), options, (message.source as any).gameTokenExchangePartners)
                    };
                    break;
                case /* mlmbox.types.Wallet.Asset.Transaction.Metadata.PositionHeader game_token_promotion_top_matrix */ 12:
                    message.source = {
                        oneofKind: "gameTokenPromotionTopMatrix",
                        gameTokenPromotionTopMatrix: Wallet_Asset_Transaction_Metadata_PositionHeader.internalBinaryRead(reader, reader.uint32(), options, (message.source as any).gameTokenPromotionTopMatrix)
                    };
                    break;
                case /* mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.SourceBinary.Partner game_token_promotion_binary */ 13:
                    message.source = {
                        oneofKind: "gameTokenPromotionBinary",
                        gameTokenPromotionBinary: Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary_Partner.internalBinaryRead(reader, reader.uint32(), options, (message.source as any).gameTokenPromotionBinary)
                    };
                    break;
                case /* mlmbox.types.Wallet.Asset.Transaction.Metadata.PositionHeader game_token_promotion_cashback */ 14:
                    message.source = {
                        oneofKind: "gameTokenPromotionCashback",
                        gameTokenPromotionCashback: Wallet_Asset_Transaction_Metadata_PositionHeader.internalBinaryRead(reader, reader.uint32(), options, (message.source as any).gameTokenPromotionCashback)
                    };
                    break;
                case /* uint32 withdrawal_gift_shop_card_id */ 15:
                    message.source = {
                        oneofKind: "withdrawalGiftShopCardId",
                        withdrawalGiftShopCardId: reader.uint32()
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wallet_Asset_Transaction_Metadata_Bonus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* mlmbox.types.Bonus.Kind.Id bonus_id = 1; */
        if (message.bonusId !== 0)
            writer.tag(1, WireType.Varint).int32(message.bonusId);
        /* mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.SourceMatrix matrix = 2; */
        if (message.source.oneofKind === "matrix")
            Wallet_Asset_Transaction_Metadata_Bonus_SourceMatrix.internalBinaryWrite(message.source.matrix, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.CardPool card_partner_dao = 3; */
        if (message.source.oneofKind === "cardPartnerDao")
            Wallet_Asset_Transaction_Metadata_Bonus_CardPool.internalBinaryWrite(message.source.cardPartnerDao, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.CardPool card_bonus_hunter = 4; */
        if (message.source.oneofKind === "cardBonusHunter")
            Wallet_Asset_Transaction_Metadata_Bonus_CardPool.internalBinaryWrite(message.source.cardBonusHunter, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string description = 5; */
        if (message.source.oneofKind === "description")
            writer.tag(5, WireType.LengthDelimited).string(message.source.description);
        /* mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.SourceBinary binary = 6; */
        if (message.source.oneofKind === "binary")
            Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary.internalBinaryWrite(message.source.binary, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.SourceBinaryMatching binary_matching = 7; */
        if (message.source.oneofKind === "binaryMatching")
            Wallet_Asset_Transaction_Metadata_Bonus_SourceBinaryMatching.internalBinaryWrite(message.source.binaryMatching, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Web3Purchase.Personal game_token_web3_purchase_personal = 8; */
        if (message.source.oneofKind === "gameTokenWeb3PurchasePersonal")
            Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Personal.internalBinaryWrite(message.source.gameTokenWeb3PurchasePersonal, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Web3Purchase.Partners game_token_web3_purchase_partners = 9; */
        if (message.source.oneofKind === "gameTokenWeb3PurchasePartners")
            Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Partners.internalBinaryWrite(message.source.gameTokenWeb3PurchasePartners, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Exchange.Personal game_token_exchange_personal = 10; */
        if (message.source.oneofKind === "gameTokenExchangePersonal")
            Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Personal.internalBinaryWrite(message.source.gameTokenExchangePersonal, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Exchange.Partners game_token_exchange_partners = 11; */
        if (message.source.oneofKind === "gameTokenExchangePartners")
            Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Partners.internalBinaryWrite(message.source.gameTokenExchangePartners, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Wallet.Asset.Transaction.Metadata.PositionHeader game_token_promotion_top_matrix = 12; */
        if (message.source.oneofKind === "gameTokenPromotionTopMatrix")
            Wallet_Asset_Transaction_Metadata_PositionHeader.internalBinaryWrite(message.source.gameTokenPromotionTopMatrix, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.SourceBinary.Partner game_token_promotion_binary = 13; */
        if (message.source.oneofKind === "gameTokenPromotionBinary")
            Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary_Partner.internalBinaryWrite(message.source.gameTokenPromotionBinary, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Wallet.Asset.Transaction.Metadata.PositionHeader game_token_promotion_cashback = 14; */
        if (message.source.oneofKind === "gameTokenPromotionCashback")
            Wallet_Asset_Transaction_Metadata_PositionHeader.internalBinaryWrite(message.source.gameTokenPromotionCashback, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* uint32 withdrawal_gift_shop_card_id = 15; */
        if (message.source.oneofKind === "withdrawalGiftShopCardId")
            writer.tag(15, WireType.Varint).uint32(message.source.withdrawalGiftShopCardId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus
 */
export const Wallet_Asset_Transaction_Metadata_Bonus = new Wallet_Asset_Transaction_Metadata_Bonus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Asset_Transaction_Metadata_Bonus_SourceMatrix$Type extends MessageType<Wallet_Asset_Transaction_Metadata_Bonus_SourceMatrix> {
    constructor() {
        super("mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.SourceMatrix", [
            { no: 1, name: "target", kind: "message", T: () => Wallet_Asset_Transaction_Metadata_PositionHeader },
            { no: 2, name: "source", kind: "message", T: () => Wallet_Asset_Transaction_Metadata_PositionHeader },
            { no: 3, name: "level", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Wallet_Asset_Transaction_Metadata_Bonus_SourceMatrix>): Wallet_Asset_Transaction_Metadata_Bonus_SourceMatrix {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.level = 0;
        if (value !== undefined)
            reflectionMergePartial<Wallet_Asset_Transaction_Metadata_Bonus_SourceMatrix>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Asset_Transaction_Metadata_Bonus_SourceMatrix): Wallet_Asset_Transaction_Metadata_Bonus_SourceMatrix {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* mlmbox.types.Wallet.Asset.Transaction.Metadata.PositionHeader target */ 1:
                    message.target = Wallet_Asset_Transaction_Metadata_PositionHeader.internalBinaryRead(reader, reader.uint32(), options, message.target);
                    break;
                case /* mlmbox.types.Wallet.Asset.Transaction.Metadata.PositionHeader source */ 2:
                    message.source = Wallet_Asset_Transaction_Metadata_PositionHeader.internalBinaryRead(reader, reader.uint32(), options, message.source);
                    break;
                case /* uint32 level */ 3:
                    message.level = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wallet_Asset_Transaction_Metadata_Bonus_SourceMatrix, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* mlmbox.types.Wallet.Asset.Transaction.Metadata.PositionHeader target = 1; */
        if (message.target)
            Wallet_Asset_Transaction_Metadata_PositionHeader.internalBinaryWrite(message.target, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Wallet.Asset.Transaction.Metadata.PositionHeader source = 2; */
        if (message.source)
            Wallet_Asset_Transaction_Metadata_PositionHeader.internalBinaryWrite(message.source, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* uint32 level = 3; */
        if (message.level !== 0)
            writer.tag(3, WireType.Varint).uint32(message.level);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.SourceMatrix
 */
export const Wallet_Asset_Transaction_Metadata_Bonus_SourceMatrix = new Wallet_Asset_Transaction_Metadata_Bonus_SourceMatrix$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary$Type extends MessageType<Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary> {
    constructor() {
        super("mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.SourceBinary", [
            { no: 1, name: "tree_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "position_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary>): Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.treeId = 0;
        message.positionId = 0;
        if (value !== undefined)
            reflectionMergePartial<Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary): Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 tree_id */ 1:
                    message.treeId = reader.uint32();
                    break;
                case /* uint32 position_id */ 2:
                    message.positionId = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 tree_id = 1; */
        if (message.treeId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.treeId);
        /* uint32 position_id = 2; */
        if (message.positionId !== 0)
            writer.tag(2, WireType.Varint).uint32(message.positionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.SourceBinary
 */
export const Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary = new Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary_Partner$Type extends MessageType<Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary_Partner> {
    constructor() {
        super("mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.SourceBinary.Partner", [
            { no: 1, name: "account_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "tree_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "position_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary_Partner>): Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary_Partner {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = 0;
        message.treeId = 0;
        message.positionId = 0;
        if (value !== undefined)
            reflectionMergePartial<Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary_Partner>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary_Partner): Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary_Partner {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 account_id */ 1:
                    message.accountId = reader.uint32();
                    break;
                case /* uint32 tree_id */ 2:
                    message.treeId = reader.uint32();
                    break;
                case /* uint32 position_id */ 3:
                    message.positionId = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary_Partner, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 account_id = 1; */
        if (message.accountId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.accountId);
        /* uint32 tree_id = 2; */
        if (message.treeId !== 0)
            writer.tag(2, WireType.Varint).uint32(message.treeId);
        /* uint32 position_id = 3; */
        if (message.positionId !== 0)
            writer.tag(3, WireType.Varint).uint32(message.positionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.SourceBinary.Partner
 */
export const Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary_Partner = new Wallet_Asset_Transaction_Metadata_Bonus_SourceBinary_Partner$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Asset_Transaction_Metadata_Bonus_SourceBinaryMatching$Type extends MessageType<Wallet_Asset_Transaction_Metadata_Bonus_SourceBinaryMatching> {
    constructor() {
        super("mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.SourceBinaryMatching", [
            { no: 1, name: "tree_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "source_account_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "source_position_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Wallet_Asset_Transaction_Metadata_Bonus_SourceBinaryMatching>): Wallet_Asset_Transaction_Metadata_Bonus_SourceBinaryMatching {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.treeId = 0;
        message.sourceAccountId = 0;
        message.sourcePositionId = 0;
        if (value !== undefined)
            reflectionMergePartial<Wallet_Asset_Transaction_Metadata_Bonus_SourceBinaryMatching>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Asset_Transaction_Metadata_Bonus_SourceBinaryMatching): Wallet_Asset_Transaction_Metadata_Bonus_SourceBinaryMatching {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 tree_id */ 1:
                    message.treeId = reader.uint32();
                    break;
                case /* uint32 source_account_id */ 2:
                    message.sourceAccountId = reader.uint32();
                    break;
                case /* uint32 source_position_id */ 3:
                    message.sourcePositionId = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wallet_Asset_Transaction_Metadata_Bonus_SourceBinaryMatching, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 tree_id = 1; */
        if (message.treeId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.treeId);
        /* uint32 source_account_id = 2; */
        if (message.sourceAccountId !== 0)
            writer.tag(2, WireType.Varint).uint32(message.sourceAccountId);
        /* uint32 source_position_id = 3; */
        if (message.sourcePositionId !== 0)
            writer.tag(3, WireType.Varint).uint32(message.sourcePositionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.SourceBinaryMatching
 */
export const Wallet_Asset_Transaction_Metadata_Bonus_SourceBinaryMatching = new Wallet_Asset_Transaction_Metadata_Bonus_SourceBinaryMatching$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Asset_Transaction_Metadata_Bonus_CardPool$Type extends MessageType<Wallet_Asset_Transaction_Metadata_Bonus_CardPool> {
    constructor() {
        super("mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.CardPool", [
            { no: 1, name: "card_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "pool_part_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Wallet_Asset_Transaction_Metadata_Bonus_CardPool>): Wallet_Asset_Transaction_Metadata_Bonus_CardPool {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cardId = 0;
        message.poolPartId = 0;
        if (value !== undefined)
            reflectionMergePartial<Wallet_Asset_Transaction_Metadata_Bonus_CardPool>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Asset_Transaction_Metadata_Bonus_CardPool): Wallet_Asset_Transaction_Metadata_Bonus_CardPool {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 card_id */ 1:
                    message.cardId = reader.uint32();
                    break;
                case /* uint32 pool_part_id */ 2:
                    message.poolPartId = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wallet_Asset_Transaction_Metadata_Bonus_CardPool, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 card_id = 1; */
        if (message.cardId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.cardId);
        /* uint32 pool_part_id = 2; */
        if (message.poolPartId !== 0)
            writer.tag(2, WireType.Varint).uint32(message.poolPartId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.CardPool
 */
export const Wallet_Asset_Transaction_Metadata_Bonus_CardPool = new Wallet_Asset_Transaction_Metadata_Bonus_CardPool$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Asset_Transaction_Metadata_Bonus_GameToken$Type extends MessageType<Wallet_Asset_Transaction_Metadata_Bonus_GameToken> {
    constructor() {
        super("mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken", []);
    }
    create(value?: PartialMessage<Wallet_Asset_Transaction_Metadata_Bonus_GameToken>): Wallet_Asset_Transaction_Metadata_Bonus_GameToken {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Wallet_Asset_Transaction_Metadata_Bonus_GameToken>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Asset_Transaction_Metadata_Bonus_GameToken): Wallet_Asset_Transaction_Metadata_Bonus_GameToken {
        return target ?? this.create();
    }
    internalBinaryWrite(message: Wallet_Asset_Transaction_Metadata_Bonus_GameToken, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken
 */
export const Wallet_Asset_Transaction_Metadata_Bonus_GameToken = new Wallet_Asset_Transaction_Metadata_Bonus_GameToken$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase$Type extends MessageType<Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase> {
    constructor() {
        super("mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Web3Purchase", []);
    }
    create(value?: PartialMessage<Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase>): Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase): Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase {
        return target ?? this.create();
    }
    internalBinaryWrite(message: Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Web3Purchase
 */
export const Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase = new Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Personal$Type extends MessageType<Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Personal> {
    constructor() {
        super("mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Web3Purchase.Personal", [
            { no: 1, name: "transaction_hash", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "amount", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Personal>): Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Personal {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.transactionHash = "";
        message.amount = "";
        if (value !== undefined)
            reflectionMergePartial<Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Personal>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Personal): Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Personal {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string transaction_hash */ 1:
                    message.transactionHash = reader.string();
                    break;
                case /* string amount */ 2:
                    message.amount = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Personal, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string transaction_hash = 1; */
        if (message.transactionHash !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.transactionHash);
        /* string amount = 2; */
        if (message.amount !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.amount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Web3Purchase.Personal
 */
export const Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Personal = new Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Personal$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Partners$Type extends MessageType<Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Partners> {
    constructor() {
        super("mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Web3Purchase.Partners", [
            { no: 1, name: "account_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "transaction_hash", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "amount", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Partners>): Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Partners {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = 0;
        message.transactionHash = "";
        message.amount = "";
        if (value !== undefined)
            reflectionMergePartial<Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Partners>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Partners): Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Partners {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 account_id */ 1:
                    message.accountId = reader.uint32();
                    break;
                case /* string transaction_hash */ 2:
                    message.transactionHash = reader.string();
                    break;
                case /* string amount */ 3:
                    message.amount = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Partners, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 account_id = 1; */
        if (message.accountId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.accountId);
        /* string transaction_hash = 2; */
        if (message.transactionHash !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.transactionHash);
        /* string amount = 3; */
        if (message.amount !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.amount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Web3Purchase.Partners
 */
export const Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Partners = new Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Web3Purchase_Partners$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange$Type extends MessageType<Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange> {
    constructor() {
        super("mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Exchange", []);
    }
    create(value?: PartialMessage<Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange>): Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange): Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange {
        return target ?? this.create();
    }
    internalBinaryWrite(message: Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Exchange
 */
export const Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange = new Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Personal$Type extends MessageType<Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Personal> {
    constructor() {
        super("mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Exchange.Personal", [
            { no: 1, name: "source", kind: "message", T: () => Asset_Amount },
            { no: 2, name: "target", kind: "message", T: () => Asset_Amount }
        ]);
    }
    create(value?: PartialMessage<Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Personal>): Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Personal {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Personal>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Personal): Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Personal {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* mlmbox.types.Asset.Amount source */ 1:
                    message.source = Asset_Amount.internalBinaryRead(reader, reader.uint32(), options, message.source);
                    break;
                case /* mlmbox.types.Asset.Amount target */ 2:
                    message.target = Asset_Amount.internalBinaryRead(reader, reader.uint32(), options, message.target);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Personal, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* mlmbox.types.Asset.Amount source = 1; */
        if (message.source)
            Asset_Amount.internalBinaryWrite(message.source, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Asset.Amount target = 2; */
        if (message.target)
            Asset_Amount.internalBinaryWrite(message.target, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Exchange.Personal
 */
export const Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Personal = new Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Personal$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Partners$Type extends MessageType<Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Partners> {
    constructor() {
        super("mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Exchange.Partners", [
            { no: 1, name: "account_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "source", kind: "message", T: () => Asset_Amount },
            { no: 3, name: "target", kind: "message", T: () => Asset_Amount }
        ]);
    }
    create(value?: PartialMessage<Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Partners>): Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Partners {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = 0;
        if (value !== undefined)
            reflectionMergePartial<Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Partners>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Partners): Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Partners {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 account_id */ 1:
                    message.accountId = reader.uint32();
                    break;
                case /* mlmbox.types.Asset.Amount source */ 2:
                    message.source = Asset_Amount.internalBinaryRead(reader, reader.uint32(), options, message.source);
                    break;
                case /* mlmbox.types.Asset.Amount target */ 3:
                    message.target = Asset_Amount.internalBinaryRead(reader, reader.uint32(), options, message.target);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Partners, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 account_id = 1; */
        if (message.accountId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.accountId);
        /* mlmbox.types.Asset.Amount source = 2; */
        if (message.source)
            Asset_Amount.internalBinaryWrite(message.source, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Asset.Amount target = 3; */
        if (message.target)
            Asset_Amount.internalBinaryWrite(message.target, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Asset.Transaction.Metadata.Bonus.GameToken.Exchange.Partners
 */
export const Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Partners = new Wallet_Asset_Transaction_Metadata_Bonus_GameToken_Exchange_Partners$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Asset_WithdrawalCapacity$Type extends MessageType<Wallet_Asset_WithdrawalCapacity> {
    constructor() {
        super("mlmbox.types.Wallet.Asset.WithdrawalCapacity", [
            { no: 1, name: "used", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "capacity", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "available", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Wallet_Asset_WithdrawalCapacity>): Wallet_Asset_WithdrawalCapacity {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.used = "";
        message.capacity = "";
        message.available = "";
        message.enabled = false;
        if (value !== undefined)
            reflectionMergePartial<Wallet_Asset_WithdrawalCapacity>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Asset_WithdrawalCapacity): Wallet_Asset_WithdrawalCapacity {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string used */ 1:
                    message.used = reader.string();
                    break;
                case /* string capacity */ 2:
                    message.capacity = reader.string();
                    break;
                case /* string available */ 3:
                    message.available = reader.string();
                    break;
                case /* bool enabled */ 4:
                    message.enabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wallet_Asset_WithdrawalCapacity, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string used = 1; */
        if (message.used !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.used);
        /* string capacity = 2; */
        if (message.capacity !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.capacity);
        /* string available = 3; */
        if (message.available !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.available);
        /* bool enabled = 4; */
        if (message.enabled !== false)
            writer.tag(4, WireType.Varint).bool(message.enabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Asset.WithdrawalCapacity
 */
export const Wallet_Asset_WithdrawalCapacity = new Wallet_Asset_WithdrawalCapacity$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Asset_List$Type extends MessageType<Wallet_Asset_List> {
    constructor() {
        super("mlmbox.types.Wallet.Asset.List", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Wallet_Asset }
        ]);
    }
    create(value?: PartialMessage<Wallet_Asset_List>): Wallet_Asset_List {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<Wallet_Asset_List>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Asset_List): Wallet_Asset_List {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated mlmbox.types.Wallet.Asset items */ 1:
                    message.items.push(Wallet_Asset.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wallet_Asset_List, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated mlmbox.types.Wallet.Asset items = 1; */
        for (let i = 0; i < message.items.length; i++)
            Wallet_Asset.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Asset.List
 */
export const Wallet_Asset_List = new Wallet_Asset_List$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Processing$Type extends MessageType<Wallet_Processing> {
    constructor() {
        super("mlmbox.types.Wallet.Processing", [
            { no: 1, name: "processing_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "processing_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "assets", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Wallet_Processing_Asset }
        ]);
    }
    create(value?: PartialMessage<Wallet_Processing>): Wallet_Processing {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.processingId = 0;
        message.processingName = "";
        message.assets = [];
        if (value !== undefined)
            reflectionMergePartial<Wallet_Processing>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Processing): Wallet_Processing {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 processing_id */ 1:
                    message.processingId = reader.uint32();
                    break;
                case /* string processing_name */ 2:
                    message.processingName = reader.string();
                    break;
                case /* repeated mlmbox.types.Wallet.Processing.Asset assets */ 3:
                    message.assets.push(Wallet_Processing_Asset.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wallet_Processing, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 processing_id = 1; */
        if (message.processingId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.processingId);
        /* string processing_name = 2; */
        if (message.processingName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.processingName);
        /* repeated mlmbox.types.Wallet.Processing.Asset assets = 3; */
        for (let i = 0; i < message.assets.length; i++)
            Wallet_Processing_Asset.internalBinaryWrite(message.assets[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Processing
 */
export const Wallet_Processing = new Wallet_Processing$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Processing_Id$Type extends MessageType<Wallet_Processing_Id> {
    constructor() {
        super("mlmbox.types.Wallet.Processing.Id", [
            { no: 1, name: "processing_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Wallet_Processing_Id>): Wallet_Processing_Id {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.processingId = 0;
        if (value !== undefined)
            reflectionMergePartial<Wallet_Processing_Id>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Processing_Id): Wallet_Processing_Id {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 processing_id */ 1:
                    message.processingId = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wallet_Processing_Id, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 processing_id = 1; */
        if (message.processingId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.processingId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Processing.Id
 */
export const Wallet_Processing_Id = new Wallet_Processing_Id$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Processing_Asset$Type extends MessageType<Wallet_Processing_Asset> {
    constructor() {
        super("mlmbox.types.Wallet.Processing.Asset", [
            { no: 1, name: "asset_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "settings_deposit_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "settings_withdrawal_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "settings_withdrawal_fee_base", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "settings_withdrawal_fee_percent", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "settings_withdrawal_operation_value_min", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "settings_withdrawal_operation_value_max", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Wallet_Processing_Asset>): Wallet_Processing_Asset {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.assetId = 0;
        message.settingsDepositEnabled = false;
        message.settingsWithdrawalEnabled = false;
        message.settingsWithdrawalFeeBase = "";
        message.settingsWithdrawalFeePercent = "";
        message.settingsWithdrawalOperationValueMin = "";
        message.settingsWithdrawalOperationValueMax = "";
        if (value !== undefined)
            reflectionMergePartial<Wallet_Processing_Asset>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Processing_Asset): Wallet_Processing_Asset {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 asset_id */ 1:
                    message.assetId = reader.uint32();
                    break;
                case /* bool settings_deposit_enabled */ 2:
                    message.settingsDepositEnabled = reader.bool();
                    break;
                case /* bool settings_withdrawal_enabled */ 3:
                    message.settingsWithdrawalEnabled = reader.bool();
                    break;
                case /* string settings_withdrawal_fee_base */ 4:
                    message.settingsWithdrawalFeeBase = reader.string();
                    break;
                case /* string settings_withdrawal_fee_percent */ 5:
                    message.settingsWithdrawalFeePercent = reader.string();
                    break;
                case /* string settings_withdrawal_operation_value_min */ 6:
                    message.settingsWithdrawalOperationValueMin = reader.string();
                    break;
                case /* string settings_withdrawal_operation_value_max */ 7:
                    message.settingsWithdrawalOperationValueMax = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wallet_Processing_Asset, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 asset_id = 1; */
        if (message.assetId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.assetId);
        /* bool settings_deposit_enabled = 2; */
        if (message.settingsDepositEnabled !== false)
            writer.tag(2, WireType.Varint).bool(message.settingsDepositEnabled);
        /* bool settings_withdrawal_enabled = 3; */
        if (message.settingsWithdrawalEnabled !== false)
            writer.tag(3, WireType.Varint).bool(message.settingsWithdrawalEnabled);
        /* string settings_withdrawal_fee_base = 4; */
        if (message.settingsWithdrawalFeeBase !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.settingsWithdrawalFeeBase);
        /* string settings_withdrawal_fee_percent = 5; */
        if (message.settingsWithdrawalFeePercent !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.settingsWithdrawalFeePercent);
        /* string settings_withdrawal_operation_value_min = 6; */
        if (message.settingsWithdrawalOperationValueMin !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.settingsWithdrawalOperationValueMin);
        /* string settings_withdrawal_operation_value_max = 7; */
        if (message.settingsWithdrawalOperationValueMax !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.settingsWithdrawalOperationValueMax);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Processing.Asset
 */
export const Wallet_Processing_Asset = new Wallet_Processing_Asset$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Processing_Asset_Id$Type extends MessageType<Wallet_Processing_Asset_Id> {
    constructor() {
        super("mlmbox.types.Wallet.Processing.Asset.Id", [
            { no: 1, name: "processing_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "asset_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Wallet_Processing_Asset_Id>): Wallet_Processing_Asset_Id {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.processingId = 0;
        message.assetId = 0;
        if (value !== undefined)
            reflectionMergePartial<Wallet_Processing_Asset_Id>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Processing_Asset_Id): Wallet_Processing_Asset_Id {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 processing_id */ 1:
                    message.processingId = reader.uint32();
                    break;
                case /* uint32 asset_id */ 2:
                    message.assetId = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wallet_Processing_Asset_Id, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 processing_id = 1; */
        if (message.processingId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.processingId);
        /* uint32 asset_id = 2; */
        if (message.assetId !== 0)
            writer.tag(2, WireType.Varint).uint32(message.assetId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Processing.Asset.Id
 */
export const Wallet_Processing_Asset_Id = new Wallet_Processing_Asset_Id$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Processing_Asset_WithdrawalAddressHistory$Type extends MessageType<Wallet_Processing_Asset_WithdrawalAddressHistory> {
    constructor() {
        super("mlmbox.types.Wallet.Processing.Asset.WithdrawalAddressHistory", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Wallet_Processing_Asset_WithdrawalAddressHistory_Value }
        ]);
    }
    create(value?: PartialMessage<Wallet_Processing_Asset_WithdrawalAddressHistory>): Wallet_Processing_Asset_WithdrawalAddressHistory {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<Wallet_Processing_Asset_WithdrawalAddressHistory>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Processing_Asset_WithdrawalAddressHistory): Wallet_Processing_Asset_WithdrawalAddressHistory {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated mlmbox.types.Wallet.Processing.Asset.WithdrawalAddressHistory.Value items */ 1:
                    message.items.push(Wallet_Processing_Asset_WithdrawalAddressHistory_Value.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wallet_Processing_Asset_WithdrawalAddressHistory, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated mlmbox.types.Wallet.Processing.Asset.WithdrawalAddressHistory.Value items = 1; */
        for (let i = 0; i < message.items.length; i++)
            Wallet_Processing_Asset_WithdrawalAddressHistory_Value.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Processing.Asset.WithdrawalAddressHistory
 */
export const Wallet_Processing_Asset_WithdrawalAddressHistory = new Wallet_Processing_Asset_WithdrawalAddressHistory$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Processing_Asset_WithdrawalAddressHistory_Value$Type extends MessageType<Wallet_Processing_Asset_WithdrawalAddressHistory_Value> {
    constructor() {
        super("mlmbox.types.Wallet.Processing.Asset.WithdrawalAddressHistory.Value", [
            { no: 3, name: "address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "last_used_at", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Wallet_Processing_Asset_WithdrawalAddressHistory_Value>): Wallet_Processing_Asset_WithdrawalAddressHistory_Value {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.address = "";
        message.lastUsedAt = 0;
        if (value !== undefined)
            reflectionMergePartial<Wallet_Processing_Asset_WithdrawalAddressHistory_Value>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Processing_Asset_WithdrawalAddressHistory_Value): Wallet_Processing_Asset_WithdrawalAddressHistory_Value {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string address */ 3:
                    message.address = reader.string();
                    break;
                case /* uint32 last_used_at */ 4:
                    message.lastUsedAt = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wallet_Processing_Asset_WithdrawalAddressHistory_Value, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string address = 3; */
        if (message.address !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.address);
        /* uint32 last_used_at = 4; */
        if (message.lastUsedAt !== 0)
            writer.tag(4, WireType.Varint).uint32(message.lastUsedAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Processing.Asset.WithdrawalAddressHistory.Value
 */
export const Wallet_Processing_Asset_WithdrawalAddressHistory_Value = new Wallet_Processing_Asset_WithdrawalAddressHistory_Value$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Wallet_Processing_List$Type extends MessageType<Wallet_Processing_List> {
    constructor() {
        super("mlmbox.types.Wallet.Processing.List", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Wallet_Processing }
        ]);
    }
    create(value?: PartialMessage<Wallet_Processing_List>): Wallet_Processing_List {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<Wallet_Processing_List>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Wallet_Processing_List): Wallet_Processing_List {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated mlmbox.types.Wallet.Processing items */ 1:
                    message.items.push(Wallet_Processing.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Wallet_Processing_List, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated mlmbox.types.Wallet.Processing items = 1; */
        for (let i = 0; i < message.items.length; i++)
            Wallet_Processing.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Wallet.Processing.List
 */
export const Wallet_Processing_List = new Wallet_Processing_List$Type();
